export default __webpack_public_path__ + "static/media/segre17.0bd81c08.jpg";